export default __webpack_public_path__ + "static/media/photo--lg--121.4a95a576.jpg";